export const LOGIN = "/login";
export const VERIFY_TOKEN = "/verify_token";
export const CUSTOMERS = "/customers";
export const CHAT_DATA_BY_ID = "/customers/chat-messages/";
export const ANALYSE = "/analyse";
export const CUSTOMERS_AI_RESPONSES = "/v3/chat/chat/ai_responses";
export const LATEST_MESSAGES = "latest-messages";
export const NEW_CUSTOMER = "new_customer";
export const SETUP_CATEGORY_TYPE = "setup/category_type";
export const ALL_CATEGORIES = "/category/all";
export const USER_WINDOW = "/Profile/:id/profile";
export const CATEGORIES = "/categories";
export const CTA_TYPES = "/cta/types";
export const CUSTOMERS_GET_TAGS = "/customers/get_tags";
export const ALL_FILTERS = "/user_access/granted_item";
export const GET_PRODUCTS = "/channels/get_products";
export const GET_TOPICS = "/topic/get_topic";
export const GET_LANGUAGES = "/channels/get_languages";
export const GET_SENTIMENTS = "/channels/get_sentiment";
export const SET_MESSAGE_VERIFICATION = "/agent_message_verification";
export const GET_ALL_PRODUCTS = "/get_products/all";
export const GET_ALL_CATEGORIES = "/get_categories/all";
export const CUSTOMERS_SUMMARY_FLOW = "/customers/responses_summary_flow";
export const OVERVIEW_METRICS = "/reporting/metrics";
export const AGENT_REPLY = "/agent_reply";
export const GET_MESSAGE_MEDIA = "/customers/get_message_media";
export const GET_ALL_USERS = "/users/subordinates";
export const USER_RESET_PASSWORD = "/users/reset_password";
export const USER_RESET_ROLE = "/user/update";
export const DELETE_USER = "/user/delete";
export const AGENTS_INVITE = "/agents/invite";
export const AGENTS_REGISTER = "/agents/register";
export const SUPPORT_SAVE = "/support_save";
export const CATEGORY_TYPE = "/category_type";
export const SALES_SETUP = "/sales_setup";
export const BUSINESS_TYPE = "/get_business_type";
export const BUSINESS_SETUP = "/save_business_setup";
export const GET_BUSINESS_SETUP = "/get_business_setup";
export const FINAL = "/final";
export const ADD_DOC = "/add_doc";
export const UPDATE_DOC = "/update_doc";
export const DELETE_DOC = "/delete_doc";
export const INVITE_USER = "/agents/invite";
export const REGISTER_USER = "agents/register";
export const FILTER_DOCUMENTS = "/qdrant/retrieve";
export const SIMULATE_DOCUMENTS = "/qdrant/search";
export const TOC_DOCUMENTS = "/qdrant/search_all";
export const GET_TOC = "/qdrant/get_toc";
export const DELETE_DOCUMENT = "/qdrant/delete_nodes";
export const UPLOAD_IMAGE = "/qdrant/image_upload";
export const UPDATE_IMAGE = "/qdrant/update_image";
export const UPLOAD_URL = "/qdrant/add_resource";
export const DELETE_IMAGE = "/qdrant/delete_image";
export const SOURCES_SEARCH_ALL = "/qdrant/search_all";
export const FETCH_QUESTIONS = "/qdrant/fetch_questions";
export const GET_ANSWER_BY_ID = "/qdrant/fetch_question_answers";
export const GET_ALL_SECTIONS = "/qdrant/section_names";
export const UPDATE_SOURCE_NODES = "/qdrant/update_nodes";
export const GENERATE_CONFLICTS = "/qdrant/generate_questions";
export const REGENERATE_QNA = "/qdrant/regenerate_answer";
export const GET_ALL_SECTIONS_FILTERS = "/qdrant/section_filters";
export const GENERATE_REPLY = "/v3/chat/reply_generate";

// Document Handler endpoints
export const DOCUMENT_HANDLER_CHECK_STATUS = "/check_status";
export const DOCUMENT_HANDLER_PROCESS = "/v3/KB/processing/?test=false";
export const DOCUMENT_HANDLER_ADD = "/add-documents";
export const DOCUMENT_HANDLER_DELETE = "/delete-documents";
export const FETCH_CHAT_HISTORY = "/channels/fetch_conversation";
export const DELETE_CHAT_HISTORY = "/v3/chat/delete_conversation";
export const FEEDBACK = "/feedback/fetch_evaluations";

// File setup endpoints
export const FILE_SETUP_LIST_DOCS = "/file_setup/list_docs";
export const FILE_SETUP_GET_DOC = "/file_setup/get_doc/{filename}";
export const FILE_SETUP_DELETE_FILE = "/file_setup/delete_file";
export const FLAG_EVALUATIONS = "/feedback/flag_evaluations";
export const EVALUATE = "/feedback/evaluate";
export const EVALUATE_FILTERS = "/feedback/evaluate_filters";
export const FEEDBACK_CONVERSATION = "/feedback/{evaluation_id}/conversation";
export const FETCH_PROMPTS = "/prompts/all";
export const UPDATE_PROMPT = "/prompts";
export const CHANGE_PASSWORD = "users/change_password";
export const CTA_FETCH = "/cta/fetch";
export const CTA_FILTERS = "/cta/cta_filters";
export const CTA_UPDATE = "/cta/update";
export const CTA_RESOLVE = "/v3/cta/resolve";
export const CTA_GET_TOPICS = "/cta/get_topics";
export const CTA_GET_AGENTS = "/cta/get_agents";
export const CTA_ASSIGN_AGENT = "/cta/assign_agent";
export const CTA_BY_ID = "/cta/get";
export const CTA_REPORTS = "/v3/cta/reports";
export const SEND_AGENT_REPLY = "/sociar-media/message-send";
export const RESOLVE_CTA_TYPE = "/v3/cta/resolve";
export const GET_TOPIC = "/topic/get_topic";

export const REPORTING_AVERAGE_PROCESSING_TIME = "/reporting/average_processing_time";
export const REPORTING_CHANNEL_MSG_COUNT = "/reporting/channel_msg_count";
export const REPORTING_CTA_COUNT = "/reporting/cta_count";
export const REPORTING_CTA_TYPE_COUNT = "/reporting/cta_type_count";
export const REPORTING_EVALUATION_COUNT = "/reporting/evaluation_count";
export const REPORTING_MESSAGE_COUNT = "/reporting/message_count";
export const REPORTING_UNIQUE_USERS_PER_DAY = "/reporting/unique_users_per_day";
export const REPORTING_LANGUAGE_COUNT = "/reporting/language_count";
export const REPORTING_TOPIC_COUNT = "/reporting/topic_count";
export const REPORTING_CHANNEL_MSG_COUNT_BY_RAW_ID = "/reporting/channel_msg_count_by_raw_id";
export const REPORTING_PRODUCT_COUNT = "/reporting/product-counts";

export const TOPIC_CRUD = "/manage-topics/topics";
export const TOPIC_BATCH = "/manage-topics/batch";

export const GET_MSG_FLAG = "/get_msg_flag";
export const GET_TEMPLATES = "/twilio/get_templates";
export const CHANGE_MSG_FLAG = "/change_msg_flag";

export const GET_CREDIT_BALANCE = "/credits/balance";
export const GET_CREDIT_HISTORY = "/credits/history";

// Email Settings Routes
export const GET_EMAIL_CONFIG = "/email_config";
export const UPDATE_EMAIL_STATUS = "/email_status";
export const ADD_EMAIL_RECIPIENT = "/email_recipient";
export const UPDATE_EMAIL_RECIPIENT_CTA_STATUS = "/email_recipient/{{email_id}}/cta_type";
export const DELETE_EMAIL_RECIPIENT = "/email_recipient/{{email_id}}";
export const UPDATE_EMAIL_RECIPIENT_STATUS = "/email_recipient/{{email_id}}/status";
export const GET_EMAIL_SERVICE_STATUS = "/email_service";
export const UPDATE_EMAIL_SERVICE_STATUS = "/email_service";

//AI Status
export const GET_AI_STATUS = "/ai/status";
export const GET_CHANNEL_STATUS = "/ai/channels";
export const ENABLE_AI_REPLY = "/ai/toggle";
export const UPDATE_AI_SCHEDULE = "/ai/schedule";

// For Tenant Setup
export const TENANT_STAGE_1 = "/tenants/stage-1";
export const TENANT_STAGE_2 = "/tenants/stage-2";
export const TENANT_SETUP_CHECK = "/tenants/setup-check";
export const TENANT_TOOLS = "/tenants/tools";
export const TENANT_ORG_TYPE = "/tenants/org-type";
export const TENANT_GET_INFO = "/tenants/business-info";
export const TENANT_DUMMY_DATA = "/tenants/dummy-data";
export const TENANT_LANGUAGE_LIST = "/tenants/language-list";
export const TENANT_PRESET_DATA = "/tenants/preset-prompt";
export const TENANT_EDIT_INFO = "/tenants/setup-process";
export const TENANT_TUTORIAL = "/tenants/tutorial";
export const CUSTOM_TOOL_CREATE = "/v3/custom-tool";
export const CUSTOM_TOOL_UPDATE = "/v3/custom-tool/";
export const CUSTOM_TOOL_DELETE = "/v3/custom-tool/";
export const CUSTOM_TOOL_LIST = "/v3/custom-tool";
export const TENANT_MSG_TEMPLATE_GET = "/tenants/msg-template";
export const TENANT_MSG_TEMPLATE_UPDATE = "/tenants/msg-template";

// For Tenant
export const GET_TENANT_INFO = "/get_tenant_id";

// Sociair Prrofiles
export const GET_SOCIAIR_PROFILES = "/sociar_webhook/sociair-profiles";
export const FETCH_SOCIAL_PAGES = "/sociar_webhook/fetch-social-pages";
export const LINK_SOCIAL_MEDIA_PROFILE = "/sociar_webhook/link-socialmedia-profile";
export const DELETE_SOCIAL_MEDIA_PROFILE = "/sociar_webhook/delete-socialmedia-profile";

// Products
export const GET_PRODUCT_LIST = "/product/products";
export const EDIT_PRODUCT = "/product/edit/";
export const GET_PRODUCT_HIERARCHY = "/product/hierarchy";
export const SYNC_PRODUCT_OVERVIEW = "/product/sync-overview";
export const MANAGE_PRODUCT_HIERARCHY = "/product/hierarchy/manage";
export const DELETE_PRODUCT_HIERARCHY_NODE = "/product/hierarchy/node";

// FAQ
export const FAQ_LIST = "/v3/faq/";
export const FAQ_CREATE = "/v3/faq/";
export const FAQ_UPDATE = "/v3/faq/";
export const FAQ_DELETE = "/v3/faq/";
export const FAQ_ATTACHMENT_UPLOAD = "/qdrant/image_upload";
export const FAQ_FILE_UPLOAD = "/v3/faq/faq-upload";
export const FAQ_SOURCES_LIST = "/v3/faq/sources-list";
export const FAQ_SOURCE_DOWNLOAD = "/v3/faq/download";
export const FAQ_FILE_DELETE = "/v3/faq/file";
export const FAQ_TAGS = "/v3/faq/tags";